$(function () {
  'use strict';
  var $collapse = $('.collapse');
  if (!$collapse.length) {
    return;
  }

  $collapse.each(function (i, el) {
    var $el = $(el);
    
    var idLookup = '' + $el.data('collapse');
    if (!idLookup) {
      return;
    }

    var $container = $(['#', idLookup, ',[data-id="', idLookup, '"]'].join(''));
    if (!$container.length) {
      return;
    }

    $container.hide();

    $el.on('click', function (e) {
      e.preventDefault();
      $container.slideToggle({
        start: function() {
          $el.children('span').toggleClass('glyph-chevron-right glyph-chevron-down');
        }
      });
    });
  });
});
